var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 11v8h2v-8h2v5h2v-5h2v8h2v-8h2v5h2v-5h2v8h2v-8h2v5h2v-5h1a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1h1zM19.29.304l.051.037L22.86 3.86a.2.2 0 0 1 .037.23l-.037.052L19.34 7.66a.2.2 0 0 1-.334-.089L19 7.517V6.2a.2.2 0 0 0-.147-.193L18.8 6h-3.6a.2.2 0 0 1-.193-.147L15 5.8V2.2a.2.2 0 0 1 .147-.193L15.2 2h3.6a.2.2 0 0 0 .193-.147L19 1.8V.483a.2.2 0 0 1 .23-.198l.06.019zM6.8.283a.2.2 0 0 1 .193.147L7 .483V1.8a.2.2 0 0 0 .147.193L7.2 2h3.6a.2.2 0 0 1 .193.147L11 2.2v3.6a.2.2 0 0 1-.147.193L10.8 6H7.2a.2.2 0 0 0-.193.147L7 6.2v1.317a.2.2 0 0 1-.29.18l-.051-.038L3.14 4.14a.2.2 0 0 1-.037-.23l.037-.052L6.66.34A.2.2 0 0 1 6.8.283z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/range.a99f0faa22ce4fc31a377844646da29b.svg";